import React from 'react';
import './Contact.css';

const Contact = () => {
  const handleAddressClick = () => {
    window.open('https://www.google.com/maps/place/Auto-Kar+mgr.+inż.+Janusz+Karwiński/@50.8882878,21.0876103,13.95z/data=!4m6!3m5!1s0x47181b0486a23541:0x680189a0473c214b!8m2!3d50.8948767!4d21.0972945!16s%2Fg%2F11cryd8r2_?entry=ttu&g_ep=EgoyMDI1MDcwOS4wIKXMDSoASAFQAw%3D%3D', '_blank');
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+48413177175';
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:autokar@interia.pl';
  };

  return (
    <section id="contact" className="contact section-padding">
      <div className="container">
        <h2 className="section-title">Skontaktuj się z nami</h2>
       
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item clickable" onClick={handleAddressClick}>
              <div className="contact-icon">📍</div>
              <div className="contact-details">
                <h3>Adres</h3>
                <p>ul. Kolejowa 22<br/>Rudki k. Nowa Słupia</p>
              </div>
            </div>
            
            <div className="contact-item clickable" onClick={handlePhoneClick}>
              <div className="contact-icon">📞</div>
              <div className="contact-details">
                <h3>Telefon</h3>
                <p>+48 41 317 71 75</p>
              </div>
            </div>
            
            <div className="contact-item clickable" onClick={handleEmailClick}>
              <div className="contact-icon">📧</div>
              <div className="contact-details">
                <h3>Email</h3>
                <p>autokar@interia.pl</p>
              </div>
            </div>
            
            <div className="contact-item">
              <div className="contact-icon">🕒</div>
              <div className="contact-details">
                <h3>Godziny pracy</h3>
                <p>Pon-Pt: 7:30 - 17:00<br/>Sob: 7:30 - 14:00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 